import { render, staticRenderFns } from "./CommunityKey.vue?vue&type=template&id=bdf2f52c&"
import script from "./CommunityKey.vue?vue&type=script&lang=js&"
export * from "./CommunityKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports